import './App.css';
import { BrowserRouter } from 'react-router-dom';
import SEOHead from './components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Impact from './components/Impact';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

// Import mock data
import {
  personalInfo,
  experience,
  education,
  skills,
  communityService,
  achievements,
  projects,
  interests,
  certifications
} from './data/mock';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <SEOHead />
        <Header />
        <main>
          <Hero personalInfo={personalInfo} />
          <About personalInfo={personalInfo} />
          <Experience experience={experience} education={education} />
          <Skills skills={skills} certifications={certifications} />
          <Impact communityService={communityService} achievements={achievements} />
          <Projects projects={projects} interests={interests} />
          <Contact personalInfo={personalInfo} />
        </main>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;